<template>
  <div
    ref="wrapper"
    class="wrapper">
    <main class="main">
      <template v-if="page">
        <template v-for="(module, index) in page.acf.modules">
          <!-- wrapper component -->
          <template v-if="module.acf_fc_layout === 'WrapperComponent'">
            <WrapperComponent
              :key="index"
              :data="module"
              :index="index">
              <template
                v-for="column in getWrapperColumns(module)"
                :key="column.key">
                <div :class="column.classes">
                  <template
                    v-for="(columnItem, columnItemIndex) in column.rows"
                    :key="`${column.key}-${columnItemIndex}`">
                    <div :class="getWrapperColumnItemClasses(columnItem)">
                      <template
                        v-for="(
                          innerModule, innerIndex
                        ) in getWrapperColumnModules(columnItem)"
                        :key="`${column.key}-${columnItemIndex}-${innerIndex}`">
                        <template
                          v-if="
                            innerModule.acf_fc_layout ===
                            'TextWithImgAndVideoComponent'
                          ">
                          <TextWithImgAndVideoComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'PatentComponent'
                          ">
                          <PatentComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'TextHeroComponent'
                          ">
                          <TextHeroComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'InformativeCardsComponent'
                          ">
                          <InformativeCardsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'SnapshotComponent'
                          ">
                          <SnapshotComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'PipelineWithFiltersComponent'
                          ">
                          <PipelineWithFiltersComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'FeaturedSimpleTextComponent'
                          ">
                          <FeaturedSimpleTextComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'AnimatedCallToActionComponent'
                          ">
                          <AnimatedCallToActionComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'InformationAccordionComponent'
                          ">
                          <InformationAccordionComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'PositionDetailsComponent'
                          ">
                          <PositionDetailsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'TextWithTwoImgsComponent'
                          ">
                          <TextWithTwoImgsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'ThreeCardsComponent'
                          ">
                          <ThreeCardsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'AnimatedColsComponent'
                          ">
                          <AnimatedColsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'CallToActionComponent'
                          ">
                          <CallToActionComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'TextBlocksComponent'
                          ">
                          <TextBlocksComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'TextRevealComponent'
                          ">
                          <TextRevealComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'HorizontalLogoAnimComponent'
                          ">
                          <HorizontalLogoAnimComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'TwoColsWithFloatingMediaComponent'
                          ">
                          <TwoColsWithFloatingMediaComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'OpenPosComponent'
                          ">
                          <OpenPosComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'PipelineComponent'
                          ">
                          <PipelineComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'PipelineComponentThree'
                          ">
                          <PipelineComponentThree
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'PublicationsComponent'
                          ">
                          <PublicationsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'PrivacyPolicyComponent'
                          ">
                          <PrivacyPolicyComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'AboutValuesComponent'
                          ">
                          <AboutValuesComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'MenuAnchorComponent'
                          ">
                          <MenuAnchorComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'TwoColsTextComponent'
                          ">
                          <TwoColsTextComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'FloatingButtonComponent'
                          ">
                          <FloatingButtonComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'GreenBoxAndTextComponent'
                          ">
                          <GreenBoxAndTextComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'PageHeroComponent'
                          ">
                          <PageHeroComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'TeamsComponent'
                          ">
                          <TeamsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'FloatingMediaComponent'
                          ">
                          <FloatingMediaComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'QuoteComponent'
                          ">
                          <QuoteComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'TextWithCardsComponent'
                          ">
                          <TextWithCardsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'CardListComponent'
                          ">
                          <CardListComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'DecorationComponent'
                          ">
                          <DecorationComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'BlogListComponent'
                          ">
                          <BlogListComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'ImageComponent'
                          ">
                          <ImageComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'SpacerComponent'
                          ">
                          <SpacerComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'HeroComponent'
                          ">
                          <HeroComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'TextWithIconComponent'
                          ">
                          <TextWithIconComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'NewPipelineComponent'
                          ">
                          <NewPipelineComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'GeneralContactComponent'
                          ">
                          <GeneralContactComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'ContactFormComponent'
                          ">
                          <ContactFormComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'LocationsComponent'
                          ">
                          <LocationsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'LocationsImageComponent'
                          ">
                          <LocationsImageComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'SimpleTextComponent'
                          ">
                          <SimpleTextComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'ContactCardsComponent'
                          ">
                          <ContactCardsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'MediaResourcesComponent'
                          ">
                          <MediaResourcesComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'ImageWithTextComponent'
                          ">
                          <ImageWithTextComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'TwoGreenColumnsComponent'
                          ">
                          <TwoGreenColumnsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'MediaComponent'
                          ">
                          <MediaComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'PDFDownloadComponent'
                          ">
                          <PDFDownloadComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'TextWitHButtonColumnsComponent'
                          ">
                          <TextWitHButtonColumnsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'BrandsComponent'
                          ">
                          <BrandsComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout === 'RevRasHeroComponent'
                          ">
                          <RevRasHeroComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'RevRasTextWithImagesComponent'
                          ">
                          <RevRasTextWithImagesComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'QuoteVideoAndTextComponent'
                          ">
                          <QuoteVideoAndTextComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'RevRasPostCarrouselComponent'
                          ">
                          <RevRasPostCarrouselComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'RevRASFeaturedPostCarrouselComponent'
                          ">
                          <RevRASFeaturedPostCarrouselComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'RevRASPostListWithFiltersComponent'
                          ">
                          <RevRASPostListWithFiltersComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'RevRASBannerWithCTAComponent'
                          ">
                          <RevRASBannerWithCTAComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>

                        <template
                          v-else-if="
                            innerModule.acf_fc_layout ===
                            'RevRASFeaturedVideoCarrouselComponent'
                          ">
                          <RevRASFeaturedVideoCarrouselComponent
                            :key="innerIndex"
                            :data="innerModule"
                            :index="innerIndex" />
                        </template>
                        <!-- standards component -->
                      </template>
                    </div>
                  </template>
                </div>
              </template>
            </WrapperComponent>
          </template>
          <!-- wrapper component -->

          <!-- standard component -->
          <template
            v-if="module.acf_fc_layout === 'TextWithImgAndVideoComponent'">
            <TextWithImgAndVideoComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'PatentComponent'">
            <PatentComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'TextHeroComponent'">
            <TextHeroComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'InformativeCardsComponent'">
            <InformativeCardsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'SnapshotComponent'">
            <SnapshotComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'PipelineWithFiltersComponent'">
            <PipelineWithFiltersComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'FeaturedSimpleTextComponent'">
            <FeaturedSimpleTextComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="
              module.acf_fc_layout === 'AnimatedCallToActionComponent'
            ">
            <AnimatedCallToActionComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="
              module.acf_fc_layout === 'InformationAccordionComponent'
            ">
            <InformationAccordionComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'PositionDetailsComponent'">
            <PositionDetailsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'TextWithTwoImgsComponent'">
            <TextWithTwoImgsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'ThreeCardsComponent'">
            <ThreeCardsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'AnimatedColsComponent'">
            <AnimatedColsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'CallToActionComponent'">
            <CallToActionComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'TextBlocksComponent'">
            <TextBlocksComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'TextRevealComponent'">
            <TextRevealComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'HorizontalLogoAnimComponent'">
            <HorizontalLogoAnimComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="
              module.acf_fc_layout === 'TwoColsWithFloatingMediaComponent'
            ">
            <TwoColsWithFloatingMediaComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'OpenPosComponent'">
            <OpenPosComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'PipelineComponent'">
            <PipelineComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'PipelineComponentThree'">
            <PipelineComponentThree
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'PublicationsComponent'">
            <PublicationsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'PrivacyPolicyComponent'">
            <PrivacyPolicyComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'AboutValuesComponent'">
            <AboutValuesComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'MenuAnchorComponent'">
            <MenuAnchorComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'TwoColsTextComponent'">
            <TwoColsTextComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'FloatingButtonComponent'">
            <FloatingButtonComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'GreenBoxAndTextComponent'">
            <GreenBoxAndTextComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'PageHeroComponent'">
            <PageHeroComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'TeamsComponent'">
            <TeamsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'FloatingMediaComponent'">
            <FloatingMediaComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'QuoteComponent'">
            <QuoteComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'TextWithCardsComponent'">
            <TextWithCardsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'CardListComponent'">
            <CardListComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'DecorationComponent'">
            <DecorationComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'BlogListComponent'">
            <BlogListComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'ImageComponent'">
            <ImageComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'SpacerComponent'">
            <SpacerComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'HeroComponent'">
            <HeroComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'TextWithIconComponent'">
            <TextWithIconComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'NewPipelineComponent'">
            <NewPipelineComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="module.acf_fc_layout === 'GeneralContactComponent'">
            <GeneralContactComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template v-else-if="module.acf_fc_layout === 'ContactFormComponent'">
            <ContactFormComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template v-else-if="module.acf_fc_layout === 'LocationsComponent'">
            <LocationsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="module.acf_fc_layout === 'LocationsImageComponent'">
            <LocationsImageComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template v-else-if="module.acf_fc_layout === 'SimpleTextComponent'">
            <SimpleTextComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="module.acf_fc_layout === 'ContactCardsComponent'">
            <ContactCardsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="module.acf_fc_layout === 'MediaResourcesComponent'">
            <MediaResourcesComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="module.acf_fc_layout === 'ImageWithTextComponent'">
            <ImageWithTextComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="module.acf_fc_layout === 'TwoGreenColumnsComponent'">
            <TwoGreenColumnsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template v-else-if="module.acf_fc_layout === 'MediaComponent'">
            <MediaComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template v-else-if="module.acf_fc_layout === 'PDFDownloadComponent'">
            <PDFDownloadComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="
              module.acf_fc_layout === 'TextWitHButtonColumnsComponent'
            ">
            <TextWitHButtonColumnsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template v-else-if="module.acf_fc_layout === 'BrandsComponent'">
            <BrandsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template v-else-if="module.acf_fc_layout === 'RevRasHeroComponent'">
            <RevRasHeroComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="
              module.acf_fc_layout === 'RevRasTextWithImagesComponent'
            ">
            <RevRasTextWithImagesComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="module.acf_fc_layout === 'QuoteVideoAndTextComponent'">
            <QuoteVideoAndTextComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="module.acf_fc_layout === 'RevRasPostCarrouselComponent'">
            <RevRasPostCarrouselComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="
              module.acf_fc_layout === 'RevRASFeaturedPostCarrouselComponent'
            ">
            <RevRASFeaturedPostCarrouselComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="
              module.acf_fc_layout === 'RevRASPostListWithFiltersComponent'
            ">
            <RevRASPostListWithFiltersComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="module.acf_fc_layout === 'RevRASBannerWithCTAComponent'">
            <RevRASBannerWithCTAComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>

          <template
            v-else-if="
              module.acf_fc_layout === 'RevRASFeaturedVideoCarrouselComponent'
            ">
            <RevRASFeaturedVideoCarrouselComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <!-- standard component -->
        </template>
      </template>
    </main>
  </div>
</template>

<script setup>
import TextWithImgAndVideoComponent from '@/components/modules/TextWithImgAndVideoComponent.vue'
import PatentComponent from '@/components/modules/PatentComponent.vue'
import TextHeroComponent from '@/components/modules/TextHeroComponent.vue'
import InformativeCardsComponent from '@/components/modules/InformativeCardsComponent.vue'
import SnapshotComponent from '@/components/modules/SnapshotComponent.vue'
import PipelineWithFiltersComponent from '@/components/modules/PipelineWithFiltersComponent.vue'
import FeaturedSimpleTextComponent from '@/components/modules/FeaturedSimpleTextComponent.vue'
import AnimatedCallToActionComponent from '@/components/modules/AnimatedCallToActionComponent.vue'
import InformationAccordionComponent from '@/components/modules/InformationAccordionComponent.vue'
import PositionDetailsComponent from '@/components/modules/PositionDetailsComponent.vue'
import TextWithTwoImgsComponent from '@/components/modules/TextWithTwoImgsComponent.vue'
import HorizontalLogoAnimComponent from '@/components/modules/HorizontalLogoAnimComponent.vue'
import ThreeCardsComponent from '@/components/modules/ThreeCardsComponent.vue'
import AnimatedColsComponent from '@/components/modules/AnimatedColsComponent.vue'
import CallToActionComponent from '@/components/modules/CallToActionComponent.vue'
import TextBlocksComponent from '@/components/modules/TextBlocksComponent.vue'
import TextRevealComponent from '@/components/modules/TextRevealComponent.vue'
import TwoColsWithFloatingMediaComponent from '@/components/modules/TwoColsWithFloatingMediaComponent.vue'
import OpenPosComponent from '@/components/modules/OpenPosComponent.vue'
import PipelineComponent from '@/components/modules/PipelineComponent.vue'
import PublicationsComponent from '@/components/modules/Publications/PublicationsComponent.vue'
import PrivacyPolicyComponent from '@/components/modules/PrivacyPolicyComponent.vue'
import AboutValuesComponent from '@/components/modules/AboutValuesComponent.vue'
import MenuAnchorComponent from '@/components/modules/MenuAnchorComponent.vue'
import FloatingButtonComponent from '@/components/modules/FloatingButtonComponent.vue'
import PageHeroComponent from '@/components/modules/PageHeroComponent.vue'
import TwoColsTextComponent from '@/components/modules/TwoColsTextComponent.vue'
import GreenBoxAndTextComponent from '@/components/modules/GreenBoxAndTextComponent.vue'
import TeamsComponent from '@/components/modules/TeamsComponent.vue'
import FloatingMediaComponent from '@/components/modules/FloatingMediaComponent.vue'
import QuoteComponent from '@/components/modules/QuoteComponent.vue'
import TextWithCardsComponent from '@/components/modules/TextWithCardsComponent.vue'
import CardListComponent from '@/components/modules/CardListComponent.vue'
import DecorationComponent from '@/components/modules/DecorationComponent.vue'
import BlogListComponent from '@/components/modules/BlogListComponent.vue'
import ImageComponent from '@/components/modules/ImageComponent.vue'
import SpacerComponent from '@/components/modules/SpacerComponent.vue'
import HeroComponent from '@/components/modules/HeroComponent.vue'
import TextWithIconComponent from '@/components/modules/TextWithIconComponent.vue'
import NewPipelineComponent from '@/components/modules/NewPipelineComponent.vue'
import PipelineComponentThree from './modules/PipelineComponentThree.vue'

/* #META
  COMPONENTS - DO NOT ERASE ANY INITIAL COMMENT
  #ENDMETA */
import RevRASFeaturedVideoCarrouselComponent from '@/components/modules/RevRASFeaturedVideoCarrouselComponent.vue'
import RevRASBannerWithCTAComponent from '@/components/modules/RevRASBannerWithCTAComponent.vue'
import RevRASPostListWithFiltersComponent from '@/components/modules/RevRASPostListWithFiltersComponent.vue'
import RevRASFeaturedPostCarrouselComponent from '@/components/modules/RevRASFeaturedPostCarrouselComponent.vue'
import RevRasPostCarrouselComponent from '@/components/modules/RevRasPostCarrouselComponent.vue'
import QuoteVideoAndTextComponent from '@/components/modules/QuoteVideoAndTextComponent.vue'
import RevRasTextWithImagesComponent from '@/components/modules/RevRasTextWithImagesComponent.vue'
import RevRasHeroComponent from '@/components/modules/RevRasHeroComponent.vue'
import BrandsComponent from '@/components/modules/BrandsComponent.vue'
import TextWitHButtonColumnsComponent from '@/components/modules/TextWitHButtonColumnsComponent.vue'
import PDFDownloadComponent from '@/components/modules/PDFDownloadComponent.vue'
import MediaComponent from '@/components/modules/MediaComponent.vue'
import TwoGreenColumnsComponent from '@/components/modules/TwoGreenColumnsComponent.vue'
import ImageWithTextComponent from '@/components/modules/ImageWithTextComponent.vue'
import MediaResourcesComponent from '@/components/modules/MediaResourcesComponent.vue'
import ContactCardsComponent from '@/components/modules/ContactCardsComponent.vue'
import SimpleTextComponent from '@/components/modules/SimpleTextComponent.vue'
import LocationsImageComponent from '@/components/modules/LocationsImageComponent.vue'
import LocationsComponent from '@/components/modules/LocationsComponent.vue'
import GeneralContactComponent from '@/components/modules/GeneralContactComponent.vue'
import ContactFormComponent from '@/components/modules/ContactFormComponent.vue'
import WrapperComponent from '@/components/modules/WrapperComponent.vue'

import { computed, onBeforeMount, onMounted, onUnmounted, nextTick } from 'vue'
import { useStore } from '@/stores/main'
import { useRouter } from 'vue-router'
import useUtils from '@/components/composables/useUtils.js'

const store = useStore()
const router = useRouter()
const props = defineProps(['slug', 'isHomepage'])
const request = {
  type: 'pages',
  slug: props.slug,
  showLoading: true,
}

const { decodeTitle } = useUtils()

const getAcfField = (source, snakeKey, camelKey) => {
  return source?.[snakeKey] ?? source?.[camelKey]
}

const isAcfEnabled = (value) => {
  return value === true || value === 1 || value === '1'
}

const toArray = (value) => {
  return Array.isArray(value) ? value : []
}

const getWrapperColumnRows = (module, snakeKey, camelKey) => {
  return toArray(getAcfField(module, snakeKey, camelKey))
}

const getWrapperColumnSettings = (columnItem) => {
  const nestedModules = columnItem?.modules

  if (nestedModules && !Array.isArray(nestedModules)) {
    return nestedModules
  }

  return columnItem || {}
}

const getWrapperColumnModules = (columnItem) => {
  const modules = columnItem?.modules

  if (Array.isArray(modules)) return modules
  if (Array.isArray(modules?.modules)) return modules.modules

  return []
}

const getWrapperColumns = (module) => {
  const leftRows = getWrapperColumnRows(module, 'left_column', 'leftColumn')
  const rightRows = getWrapperColumnRows(module, 'right_column', 'rightColumn')
  const shouldShowRightColumn =
    isAcfEnabled(getAcfField(module, 'add_column', 'addColumn')) &&
    rightRows.length > 0

  const columns = [
    {
      key: 'left',
      rows: leftRows,
      classes: [
        'wrapper-module-component__column',
        'wrapper-module-component__column--left',
      ],
    },
  ]

  if (shouldShowRightColumn) {
    columns.push({
      key: 'right',
      rows: rightRows,
      classes: [
        'wrapper-module-component__column',
        'wrapper-module-component__column--right',
      ],
    })
  }

  return columns
}

const getWrapperColumnItemClasses = (columnItem) => {
  const settings = getWrapperColumnSettings(columnItem)

  return {
    'wrapper-module-component__column-item': true,
    'hide-on-mobile': isAcfEnabled(
      getAcfField(settings, 'hide_on_mobile', 'hideOnMobile')
    ),
    'hide-on-tablet': isAcfEnabled(
      getAcfField(settings, 'hide_on_tablet', 'hideOnTablet')
    ),
    'hide-on-desktop': isAcfEnabled(
      getAcfField(settings, 'hide_on_desktop', 'hideOnDesktop')
    ),
  }
}

const page = computed(() => {
  return store.getCurrentSingleBySlug(request)
})

onBeforeMount(() => getPage())

onMounted(() => {
  const anchor = router.currentRoute.hash
  nextTick(() => {
    if (anchor && document.querySelector(anchor)) {
      location.href = anchor
    }
  })
})

const getPage = async () => {
  store.getSingleBySlug(request).then(() => {
    if (page.value) {
      store.setHideNav(!!page.value.acf?.hide_nav_links)
      if (!props.isHomepage) {
        store.updateDocTitle({
          parts: [decodeTitle(page.value.title.rendered), store.site.name],
        })
      } else {
        store.updateDocTitle({
          parts: [null, store.site.name],
        })
      }
    } else {
      router.replace('/404')
    }
  })
}

onUnmounted(() => {
  store.setHideNav(false)
})

// const normalizeData = (type) => {
//   if (type) {
//     const filtered = store.getCurrentSingleBySlug(request)
//     const rawData = store.getPosts({ type: type })
//     if (filtered) {
//       for (const module of filtered.acf.modules) {
//         if (module.acf_fc_layout === type) {
//           const data = Object.entries(rawData).map((x) => x[1])
//           data.pop()
//           module[type] = data
//         }
//       }
//     }
//   }
// }
</script>

<style lang="scss"></style>
